
import PropTypes from 'prop-types'

import { IconButton } from '../../../shared/NarusMaterial'

import DueDays from './DueDays'

export const ActionDescription = ({
  dueDate,
  description,
  isOpen,
  onOpen,
  inCarePlan,
  dueDays
}) => {
  const caretClass = isOpen ? 'caret-down' : 'caret-right'

  const caret = () => (
    <div className='icon-button-wrapper'>
      <IconButton
        onClick={onOpen}
        fontAwesomeIcon={caretClass}
      />
    </div>
  )

  return (
    <div className='action-description'>
      {inCarePlan && caret()}
      <div className='badge-wrapper'>
        <DueDays
          date={dueDate}
          count={dueDays}
        />
      </div>
      <div className='description'>{description}</div>
    </div>
  )
}

ActionDescription.propTypes = {
  description: PropTypes.string.isRequired,
  dueDate: PropTypes.any,
  dueDays: PropTypes.any,
  inCarePlan: PropTypes.bool,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func
}
